import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';
const importEnv = require('./_import_' + process.env.NODE_ENV);
export default [
    {
        path: '/user/:userid/order',
        component: BasicLayout,
        children: [
            {
                path: 'manage',
                name: 'orderManageOld',
                redirect: '/user/:userid/userCenter/order',
                meta: {
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('Order', () =>
                    import('../model/Order')
                ),
                component: importEnv('Order/index')
            }
        ]
    }
];
